export default __webpack_public_path__ + "media/images/icons/quote-marks-dcf73a8591384aebc6a7e469dbccd841.svg";